"use client";
import React from "react";
import Image from "next/image";
import { Award } from "@/types/Customizations";
import { CourseAwardsProps } from "./types";
import { fixUrlSrc } from "@/utils/functions/fixUrlSrc";
import { validAwards } from "@/components/CourseContent/templates/common/utils/validAwards";
import { cn } from "@/lib/utils";
import useTranslations from "@/i18n/useTranslations";

function CourseAwards({
  awards,
  isSpanish,
  width = 100,
  height = 120,
  title,
  awardsContainerClassName,
  className,
}: CourseAwardsProps) {
  const t = useTranslations("Common");

  if (!awards || awards.length === 0) {
    return null;
  }

  const filteredAwards = validAwards(awards);

  if (filteredAwards.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <h2 className="mt-0 pt-0 mb-6 md:text-3xl">{title || t("awards")}</h2>
      <div
        className={cn(
          "flex flex-col items-center md:flex-row md:items-start gap-4 flex-wrap",
          awardsContainerClassName,
        )}
      >
        {filteredAwards.map((award: Award) => {
          const image = isSpanish
            ? award.spanishImage?.[0]
            : award.englishImage?.[0];
          const altText = isSpanish
            ? award.spanishAltText
            : award.englishAltText;
          const orientationClass =
            award.orientation?.toLowerCase() || "default";
          return (
            <Image
              key={`award-${image?.fileFileName}`}
              // TODO: Remove https: prefix when we start using the url instead of the file.url
              src={fixUrlSrc(image?.fileUrl) || ""}
              alt={altText || t("awardImage")}
              width={width}
              height={height}
              className={`storefront-course-award ${orientationClass}`}
              quality={50}
            />
          );
        })}
      </div>
    </div>
  );
}

export default CourseAwards;
